export const GENERATE_TABS = ({
  generalInformationCommentsCount,
  residentialDetailsCommentsCount,
  fileUploadCommentsCount,
  changeDocumentsCommentsCount,
}) => {
  const INITIAL_TABS = [
    { id: "assignOfficials", label: "Assign Officials" },
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "KYC Documents",
      commentsCount: fileUploadCommentsCount,
    },
    {
      id: "uploadChangeDocuments",
      label: "Change Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
  ];
  const SHORT_FORM_TABS = [
    { id: "assignOfficials", label: "Assign Officials" },
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "Upload Documents",
      commentsCount: fileUploadCommentsCount,
    },
  ];
  const LONG_FORM_TABS = [
    { id: "assignOfficials", label: "Assign Officials" },
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "Upload Documents",
      commentsCount: fileUploadCommentsCount,
    },
  ];
  const APPLICATION_CORRECTION_TABS = [
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "KYC Documents",
      commentsCount: fileUploadCommentsCount,
    },
    {
      id: "uploadChangeDocuments",
      label: "Change Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
  ];
  const MANAGE_MODULE_EDIT_TABS = [
    {
      id: "generalInformation",
      label: "General Information",
      commentsCount: generalInformationCommentsCount,
    },
    {
      id: "residentialDetails",
      label: "Address Details",
      commentsCount: residentialDetailsCommentsCount,
    },
    {
      id: "uploadDocuments",
      label: "KYC Documents",
      commentsCount: fileUploadCommentsCount,
    },
    {
      id: "uploadChangeDocuments",
      label: "Change Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
    {
      id: "uploadDirectorApprovalDocuments",
      label: "Director Approval Documents",
      commentsCount: changeDocumentsCommentsCount,
    },
  ];
  return {
    INITIAL_TABS,
    SHORT_FORM_TABS,
    LONG_FORM_TABS,
    APPLICATION_CORRECTION_TABS,
    MANAGE_MODULE_EDIT_TABS,
  };
};
